import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import DataTable from "../Reusable/DataTable";
import { useState } from "react";
import usePermission from "../../customHooks/usePermission";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { StatusCell } from "./Status";
const LongTextCell = ({ getValue }: any) => {
  const value = getValue();

  return (
    <div
      title={value}
      className="max-w-[260px] line-clamp-2 text-sm leading-snug cursor-help"
    >
      {value}
    </div>
  );
};

const LeaveApplicationList = (props: any) => {
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };

  const defaultColumns: any = [
    {
      header: "Employee Name",
      accessorKey: "user_name",
      cell: NACell,
    },
    {
      header: "Start Date",
      accessorKey: "start_date",
      cell: NACell,
    },
    {
      header: "End Date",
      accessorKey: "end_date",
      cell: NACell,
    },
    {
      header: "Reason",
      accessorKey: "reason",
      cell: LongTextCell,
    },

    {
      header: "Approved By",
      accessorKey: "approved_by",
      cell: NACell,
    },
    {
      header: "Admin Remark",
      accessorKey: "admin_remark",
      cell: LongTextCell,
    },
    {
      header: "Created At",
      accessorKey: "created",
      cell: ({ getValue }) => {
        const value = getValue();

        return (
          <div className="flex flex-col leading-tight">
            <span className="font-medium">
              {moment(value).format("MMM DD, YYYY")}
            </span>
            <span className="text-xs text-gray-500">
              {moment(value).format("hh:mm A")}
            </span>
          </div>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.LEAVE}
        queryKey={"leave-application"}
        params={{}}
        columns={defaultColumns}
        tableName={"leave-application"}
        // addNewPagePath={"create"}
      />
    </>
  );
};

export default LeaveApplicationList;
